module.exports = __webpack_public_path__ + "static/img/9.36f7735.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/9.png
// module id = 0ojK
// module chunks = 0